export default {
  description: 'Ahora podés realizar tu compra',
  msisdn_description: 'Introducí tu número'
}
